import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface SignupPageIntroProps {
  children?: ReactNode;
}


export function SignupPageIntro({ children }: SignupPageIntroProps) {
  return (
    <div className="space-y-3 lg:min-h-17">
      <div className="space-y-2">
        <h1 className="text-3xl font-semibold tracking-[-0.015em] text-content-primary">
          Start your free trial
        </h1>
        <p className="type-body text-content-primary">
          Better data. Lower CAC. Setup in under 20 minutes.
        </p>
      </div>
      {children}
    </div>
  );
}

interface SignupFormPanelProps {
  children: ReactNode;
  className?: string;
}

export function SignupFormPanel({ children, className }: SignupFormPanelProps) {
  return (
    <div
      className={cn(
        'rounded-overlay border border-border bg-card p-6 shadow-overlay sm:p-8',
        className
      )}
    >
      {children}
    </div>
  );
}
